// PGCET MCA Mock 4 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "Find the next number in the series: 2, 3, 10, 15, 26, 35, 50, ?",
    options: ["A. 63", "B. 65", "C. 64", "D. 72"],
    answer: "A"
  },
  {
    id: 57,
    question: "Find the next number in the series: 5, 11, 24, 51, 106, ?",
    options: ["A. 212", "B. 217", "C. 215", "D. 219"],
    answer: "B"
  },
  {
    id: 58,
    question: "In a certain code language, COMPUTER is written as RFUVQNPC. How is MEDICINE written in that code?",
    options: ["A. EOJDKEFM", "B. MFEJDJOE", "C. EOJDJEFM", "D. ENJDJEFM"],
    answer: "C"
  },
  {
    id: 59,
    question: "If A + B means A is the mother of B, A − B means A is the brother of B, A × B means A is the father of B and A ÷ B means A is the sister of B, which of the following shows that P is the maternal uncle of Q?",
    options: ["A. P × M − Q", "B. P + M − Q", "C. P ÷ M + Q", "D. P − M + Q"],
    answer: "D"
  },
  {
    id: 60,
    question: `Statements: All pens are books. Some books are tables. No table is a chair.
      Conclusions:
      I. Some books are not chairs.
      II. Some pens are tables.`,
    options: ["A. Only conclusion II follows", "B. Only conclusion I follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "B"
  },
  {
    id: 61,
    question: "Six friends A, B, C, D, E and F sit equally spaced around a circular table. A sits opposite D. B sits next to A. E sits between C and D. Who sits opposite B?",
    options: ["A. C", "B. F", "C. E", "D. D"],
    answer: "C"
  },
  {
    id: 62,
    question: "Starting from point O, a man walks 6 km east, turns left and walks 4 km, turns left again and walks 9 km, then turns left and walks 8 km. How far is he from O, and in which direction?",
    options: ["A. 5 km, South-West", "B. 5 km, North-West", "C. 7 km, South-West", "D. 3 km, West"],
    answer: "A"
  },
  {
    id: 63,
    question: "If P > Q ≥ R = S < T, which of the following is definitely true?",
    options: ["A. Q > S", "B. P > S", "C. T > Q", "D. R > T"],
    answer: "B"
  },
  {
    id: 64,
    question: "At what time between 4 o'clock and 5 o'clock do the hour hand and the minute hand of a clock coincide?",
    options: ["A. 4:20", "B. 4:21 3/11", "C. 4:22 2/11", "D. 4:21 9/11"],
    answer: "D"
  },
  {
    id: 65,
    question: `What is the two-digit number N?
      Statement I: The sum of the digits of N is 9.
      Statement II: The number formed by reversing the digits of N is 27 more than N.`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "C"
  },
  {
    id: 66,
    question: "In a class of 100 students, 55 study Mathematics, 45 Physics and 40 Chemistry; 20 study Mathematics and Physics, 15 Physics and Chemistry, 18 Mathematics and Chemistry, and 8 study all three. How many students study exactly one of the three subjects?",
    options: ["A. 58", "B. 53", "C. 63", "D. 45"],
    answer: "A"
  },
  {
    id: 67,
    question: "In a row of 40 students, Ravi is 14th from the left and Mohan is 17th from the right. How many students stand between them?",
    options: ["A. 10", "B. 9", "C. 8", "D. 11"],
    answer: "B"
  },
  {
    id: 68,
    question: "Find the missing term: 3 : 28 :: 5 : ?",
    options: ["A. 125", "B. 124", "C. 150", "D. 126"],
    answer: "D"
  },
  {
    id: 69,
    question: "If '+' means '×', '−' means '÷', '×' means '−' and '÷' means '+', then the value of 18 − 3 + 4 × 6 ÷ 2 is",
    options: ["A. 20", "B. 18", "C. 24", "D. 16"],
    answer: "A"
  },
  {
    id: 70,
    question: "Five boxes P, Q, R, S and T are stacked one above another. T is not above any box. Q is immediately above T. S is above P, and P is above R. Which box is in the middle of the stack?",
    options: ["A. P", "B. Q", "C. S", "D. R"],
    answer: "D"
  }
];

export default pgcetmcaAnalyticalReasoning;
